import { useEffect, useState } from "react";
import { breakpoint } from "../styles/theme";

const classify = (width) => ({
  width,
  isMobile: width <= breakpoint.mobile,
  isTablet: width > breakpoint.mobile && width <= breakpoint.tablet,
  isDesktop: width > breakpoint.tablet,
  // Convenience flag for "narrow enough that the sidebar shouldn't be
  // permanently on-screen" — same threshold Sidebar/Layout collapse at.
  isCompact: width <= breakpoint.tablet,
});

/**
 * Tracks window width and classifies it against the shared breakpoint
 * tokens (styles/theme.js). Since this codebase styles with inline
 * `style={{}}` objects rather than CSS modules (see theme.js's docstring),
 * this is how a component branches its own inline styles responsively —
 * `const { isMobile } = useViewport(); style={{ flexDirection: isMobile ? "column" : "row" }}`
 * — rather than relying on CSS media queries, which inline styles can't use.
 *
 * Debounced via rAF-throttling implicitly through the resize listener being
 * cheap (just a classify() on a number) — no need for explicit debounce at
 * this scale.
 */
const useViewport = () => {
  const [viewport, setViewport] = useState(() =>
    classify(typeof window !== "undefined" ? window.innerWidth : breakpoint.tablet + 1)
  );

  useEffect(() => {
    const onResize = () => setViewport(classify(window.innerWidth));
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return viewport;
};

export default useViewport;
